// der folgende Code ist kopiert von WebGLMaterials.js / refreshUniformsCommon (Zeile 108)
// und gibt zu einem Material die für die uvTransform relevante Map zurück
export const getMaterialUvTransformMap = material => {

    let uvScaleMap;

    if (material.map) {

        uvScaleMap = material.map;

    } else if (material.specularMap) {

        uvScaleMap = material.specularMap;

    } else if (material.displacementMap) {

        uvScaleMap = material.displacementMap;

    } else if (material.normalMap) {

        uvScaleMap = material.normalMap;

    } else if (material.bumpMap) {

        uvScaleMap = material.bumpMap;

    } else if (material.roughnessMap) {

        uvScaleMap = material.roughnessMap;

    } else if (material.metalnessMap) {

        uvScaleMap = material.metalnessMap;

    } else if (material.alphaMap) {

        uvScaleMap = material.alphaMap;

    } else if (material.emissiveMap) {

        uvScaleMap = material.emissiveMap;

    } else if (material.clearcoatMap) {

        uvScaleMap = material.clearcoatMap;

    } else if (material.clearcoatNormalMap) {

        uvScaleMap = material.clearcoatNormalMap;

    } else if (material.clearcoatRoughnessMap) {

        uvScaleMap = material.clearcoatRoughnessMap;

    } else if (material.specularIntensityMap) {

        uvScaleMap = material.specularIntensityMap;

    } else if (material.specularColorMap) {

        uvScaleMap = material.specularColorMap;

    } else if (material.transmissionMap) {

        uvScaleMap = material.transmissionMap;

    } else if (material.thicknessMap) {

        uvScaleMap = material.thicknessMap;

    } else if (material.sheenColorMap) {

        uvScaleMap = material.sheenColorMap;

    } else if (material.sheenRoughnessMap) {

        uvScaleMap = material.sheenRoughnessMap;

    }

    if (uvScaleMap?.isWebGLRenderTarget) {
        uvScaleMap = uvScaleMap.texture;
    }

    return uvScaleMap;
}

export const getMaterialUvTransform = material => {

    const uvScaleMap = getMaterialUvTransformMap(material);

    if (uvScaleMap?.matrixAutoUpdate) {

        uvScaleMap.updateMatrix();

    }

    return uvScaleMap?.matrix;
}
